<button
  type="button"
  class="ss-table-export"
  aria-label="Baixar planilha"
  data-ss-tooltip="Baixar planilha"
  [disabled]="disabled"
  (click)="requestExport($event)"
  (keydown.enter)="$event.stopPropagation()"
  (keydown.space)="$event.stopPropagation()">
  <lucide-icon name="download" [size]="15" aria-hidden="true"></lucide-icon>
</button>
